/**
 * Picks v2 or v1 of the Tapping Point edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import TappingPointsAddEditPage   from './TappingPointsAddEditPage';
import TappingPointsAddEditPageV2 from './TappingPointsAddEditPageV2';

export default function TappingPointsAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? TappingPointsAddEditPageV2 : TappingPointsAddEditPage;
  return <Component {...props} />;
}
